export { default } from "@casino/client/components/CashierWrap/useCashier/useOpenCloseCashier";
